import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingsContainerComponent } from './components/settings-container/settings-container.component';

const routes: Routes = [
    {
      path: '',
      component:SettingsContainerComponent,
      children: [
        {
          path: 'users',
          loadChildren: () => import('../users/users.module').then((m)=>m.UsersModule),
        },
        {
          path: 'org',
          loadChildren: () => import('../organization/organization.module').then((m)=>m.OrganizationModule),
        },
        {
          path: 'roles',
          loadChildren: () => import('../role/role.module').then((m)=>m.RoleModule),
        },
        {
          path: '',
          redirectTo: 'users',
          pathMatch: 'full'
        }
      ]
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule { }
